var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment_s",
    transform: "translate(-1369.001 -399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attachment_black_24dp",
    transform: "translate(1369.001 399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47111",
    "data-name": "Path 47111",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47112",
    "data-name": "Path 47112",
    d: "M13.687,13.625H5.752a3.087,3.087,0,0,1-3.113-2.707A3,3,0,0,1,5.624,7.625h9.27a1.947,1.947,0,0,1,1.972,1.68A1.875,1.875,0,0,1,15,11.375H7.124a.75.75,0,0,1,0-1.5h6.562a.563.563,0,1,0,0-1.125H7.229a1.947,1.947,0,0,0-1.973,1.68A1.875,1.875,0,0,0,7.124,12.5h7.747a3.087,3.087,0,0,0,3.113-2.707A3,3,0,0,0,15,6.5H5.8a4.244,4.244,0,0,0-4.283,3.72,4.129,4.129,0,0,0,4.11,4.53h8.062a.563.563,0,1,0,0-1.125Z",
    transform: "translate(1368.504 397.5)",
    fill: "#92a1b6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentS);
export default __webpack_public_path__ + "static/media/attachment_s.adc2ba5c19930e61ba874e512e4dd68a.svg";
export { ForwardRef as ReactComponent };